module.exports = __webpack_public_path__ + "static/media/Max75_in.86a50693.jpg";